import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip } from 'antd';
import Swal from 'sweetalert2';
import { UnLockUser } from 'redux/slices/userSlice';
import { SpanButton } from 'component/button_components/button.style';
import { LockIcon } from 'assets/icons/AntDeisgn_icons/iconStyle';
import { SweetSweetAlert } from 'component/sweetalert_components';
import { ReactComponent as UnlockIcon } from 'assets/images/SVG/icons/unlock-icon.svg';
import { useRefreshUserTab } from 'component/table_component/users_data/refreshUserData';
import ModalOpenLoader from 'component/loader_component/modalOpenLoader';

export default function LockUnlockModal({ ...record }) {
  const dispatch = useDispatch();
  const refreshUserTab = useRefreshUserTab();
  const [loader, setLoader] = useState(false);
  const selectedNode = useSelector((state) => state.selectedNode);
  const { mailUnlockUser } = useSelector((state) => state.settings);
  const canNotify = mailUnlockUser ?? true;

  const showSweetAlert = async () => {
    const htmlContent = `
    <div class='af-user-unlock-notify-wrap' style="display: flex; align-items: center; justify-content: center;">
      <input class="af-user-unlock-notify-input" type="checkbox" id="notifyByEmail" style=" width: 30px; height: 20px;">
      <label class="af-user-unlock-notify-label" for="notifyByEmail">Notify by email</label>
    </div>
      `;
    const result = await Swal.fire({
      icon: 'warning',
      title: `Are you sure you want to unlock ${record.samAccountName}`,
      html: htmlContent,
      showConfirmButton: true,
      confirmButtonColor: 'var(--bg-button-default-color)',
      width: '400px',
      heightAuto: false,
      showCancelButton: true,
      cancelButtonColor: 'green',
      confirmButtonText: 'Unlock',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
      customClass: {
        container: 'custom-swal-container',
        icon: 'custom-swal-icon',
        title: 'custom-swal-title',
      },
      didRender: () => {
        const notifyEmailUnlock = document.getElementById('notifyByEmail');
        notifyEmailUnlock.checked = canNotify;
      },
      preConfirm: () => {
        return {
          notifyByEmail: document.getElementById('notifyByEmail').checked,
        };
      },
    });

    if (result.isConfirmed) {
      try {
        setLoader(true);
        let values = [
          {
            userName: record.dn,
            fqdn: selectedNode.domainName,
            notifyEmail: result.value.notifyByEmail,
            domainId: selectedNode.currentdomainId,
          },
        ];
        const sweetAlert = await dispatch(UnLockUser(values));
        if (sweetAlert.payload && sweetAlert.payload.status === 200) {
          await SweetSweetAlert({
            sweetData: sweetAlert.payload.data[0].includes(':')
              ? sweetAlert.payload.data[0].split(':')[1]
              : sweetAlert.payload.data,
            icon: 'success',
            buttonColor: 'green',
          });
        } else {
          SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
        }
      } catch (error) {
        await SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
      } finally {
        setLoader(false);
        await refreshUserTab();
      }
    }
  };
  if (record.isLock === false) {
    return (
      <>
        {loader && <ModalOpenLoader />}
        <Tooltip className='af-user-unlock-tooltip' title=' Status : UnLocked' color='#597081'>
          <SpanButton className='af-user-unlock-tooltip-button'>
            <UnlockIcon className='af-user-unlock-tooltip-icon' />
          </SpanButton>
        </Tooltip>
      </>
    );
  }

  return (
    <>
      {loader && <ModalOpenLoader />}
      <SpanButton
        className='af-user-lock-tooltip-button'
        type='primary'
        onClick={showSweetAlert}
        style={{ backgroundColor: 'red' }}
      >
        <Tooltip className='af-user-lock-tooltip' title=' Status : Locked. Click to Unlock.' color='#597081'>
          <LockIcon className='af-user-lock-tooltip-icon' />
        </Tooltip>
      </SpanButton>
    </>
  );
}
